import React from "react"
import styled from "styled-components"
import SEO from "../components/seo"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import { HeadingTwo, Article } from "../elements"
import { linkAccent, lightMetaAccent, breakpointMedium } from "../variables"
import { formatDate } from "../helpers"
import PostSlicesContainer from "../components/postSlicesContainer"
import PostNextData from "../components/postNextData"

const Post = ({ data, pageContext }) => {
  const nextData = pageContext.next
  const tags = data.allPrismicPost.edges[0].node.tags
  const {
    title,
    description,
    release_date,
    source,
    featured_image,
  } = data.allPrismicPost.edges[0].node.data
  const doc = data.allPrismicPost.edges.slice(0, 1).pop()
  const slices = doc.node.data.body

  return (
    <Layout>
      <SEO title={title.text} description={description.text} />
      <Article maxWidth="1108px" margin="0 auto" css={{ minHeight: "100vh" }}>
        <PostTitle textAlign="center" padding="67px 0 0 0">
          {title.text}
        </PostTitle>
        <PostInfo>
          {formatDate(release_date)} | {source.text}
        </PostInfo>
        <FeaturedImage
          className="featured-image"
          src={featured_image.url}
          alt={featured_image.alt}
        />
        <PostSlicesContainer slices={slices} />
        {tags.length !== 0 && (
          <Tags>
            {" "}
            <p>TAGS:</p>{" "}
            <p className="tag-container">
              {tags.map((tag, i) => (
                <Link key={i} to={`/tags/${tag}`}>
                  <span className="tag">{tag}</span>
                </Link>
              ))}
            </p>
          </Tags>
        )}
      </Article>
      <PostNextData nextData={nextData} />
    </Layout>
  )
}

export default Post

const FeaturedImage = styled.img`
  width: 100%;
`

const PostTitle = styled(HeadingTwo)`
  font-size: 32px;

  @media (min-width: 1366px) {
    font-size: 36px;
  }
`

const Tags = styled.span`
  padding: 40px 20px 109px 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  line-height: 0;

  .tag-container {
    margin-left: 10px;
  }

  .tag {
    font-weight: 700;
    margin-right: 5px;
    color: ${linkAccent};
  }

  @media (min-width: ${breakpointMedium}) {
    padding: 40px 0px 109px 0px;
  }
`

const PostInfo = styled.span`
  font-size: 15px;
  display: flex;
  padding: 43px 0 33px 0;
  justify-content: center;
  color: ${lightMetaAccent};
`

export const query = graphql`
  query($title: String) {
    allPrismicPost(filter: { data: { title: { text: { eq: $title } } } }) {
      edges {
        node {
          tags
          first_publication_date
          data {
            title {
              text
            }
            description {
              html
              text
            }
            featured_image {
              url
              alt
            }
            release_date
            source {
              text
            }
            body {
              ... on PrismicPostBodyTextSection {
                slice_type
                primary {
                  content {
                    html
                  }
                }
              }
              ... on PrismicPostBodyImage {
                slice_type
                primary {
                  image {
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 3080, quality: 90) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                  caption {
                    html
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
